<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="maintenance">
        <img :src="closeIconSrc" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_game_maintenance_title }}</h1>
        <img src="static/images/profile/profile-emptystate.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_game_maintenance_description_1 }}<br>
          {{ getTranslations.home_modals_game_maintenance_description_2 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'game-maintenance',
  mixins: [SkinMixin],
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Maintenance.vue